import { render, staticRenderFns } from "./EsterilizacaoManufatura.vue?vue&type=template&id=e3b8e942&"
import script from "./EsterilizacaoManufatura.vue?vue&type=script&lang=js&"
export * from "./EsterilizacaoManufatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports